import { Direction } from '@angular/cdk/bidi';
import { Component, Input, OnInit } from '@angular/core';
import { MenuPositionX } from '@angular/material/menu';
import { SelectOption } from 'src/app/@shared/interfaces/select-option.interface';
import { LanguageService } from 'src/app/@shared/services/language/language.service';

@Component({
    selector: 'mot-menu',
    templateUrl: './mot-menu.component.html',
    styleUrls: ['./mot-menu.component.scss'],
    standalone: false
})
export class MotMenuComponent<T> implements OnInit{

  @Input() menuVert: boolean = false;
  @Input() menuItems: SelectOption<T>[];
  @Input() menuPositionX: MenuPositionX = 'before';
  @Input() menuClass: string | string[] | Set<string> | { [klass: string]: any };
  @Input() menuItemClass: string | string[] | Set<string> | { [klass: string]: any };
  @Input() buttonClass: string | string[] | Set<string> | { [klass: string]: any };
  @Input() buttonActiveClass: string | string[] | Set<string> | { [klass: string]: any };
  @Input() heightClass: string = ""
  /** Accessibility: label for the menu trigger button (e.g. "More actions"). */
  @Input() menuButtonAriaLabel: string = '';

  menuButtonClass: string | string[] | Set<string> | { [klass: string]: any };
  isMenuOpen = false;

  direction: Direction

  constructor(private readonly languageService: LanguageService) {}

   ngOnInit(): void {
    this.languageService.selectedLanguage$.subscribe((language) => {
      this.direction = language.direction
    })
  }

  onMenuOpened(): void {
    this.isMenuOpen = true;
  }

  onMenuClosed(): void {
    this.isMenuOpen = false;
    this.menuButtonClass = this.buttonClass;
  }

  handleMenuItemClick(_evt: MouseEvent, menuItem: SelectOption<T>) {
    if (menuItem.disabled || !menuItem.onClick) {
      return;
    }
    menuItem.onClick(menuItem.value);
  }
}
